export default __webpack_public_path__ + "static/media/star-badge.7fe38509.svg";